export default "__VITE_ASSET__ko4DP3E3oMV7GxqZL0NGuQ__"